import axios from 'axios'
import { ref } from 'vue'
import { APIS_GESTOR, APIS_LTE, TIMEOUTTIME } from '@/constants/apis'
import { showConsoleError } from '@/functions/errors';
import { DATABASEINFO, ENLACES, ENLACEBYNAME, LTE_ENLACES, LTE_PARAM, LASTENLACEINFO, ALLDATAINFO } from '@/interfaces/GestorHCGLINK/Equips';
import { EQUIPOS } from '@/interfaces/SmartLink/Equipos';
import { TOKEN } from '@/constants/labels';
// const TIMEOUT = TIMEOUTTIME

export async function getMaxDatesLTEGestor() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_GESTOR.value.getMaxDatesLTE, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<string[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalData.forEach((item: EQUIPOS) => {
          if (item.fecha) finalObj.value.push(item.fecha);
        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}


export async function getLastDatesLTEGestor(params: LTE_PARAM) {
  const statusAxios = ref();

  try {
    const response = await axios.get(APIS_GESTOR.value.getLastLTE, {
      params: params,
      timeout: TIMEOUTTIME,
      headers: { Authorization: `Bearer ${TOKEN}` }
    });

    const finalData: LTE_ENLACES[] = response.data;
    const showGraphs = finalData.length > 0;
    const finalObj: LASTENLACEINFO = {};

    if (showGraphs) {
      // 1. Agrupar los registros por IP
      const agrupadoPorIp: Record<string, DATABASEINFO[]> = {};

      finalData.forEach((item: DATABASEINFO) => {
        if (!agrupadoPorIp[item.ip]) {
          agrupadoPorIp[item.ip] = [];
        }
        agrupadoPorIp[item.ip].push(item);
      });

      // 2. Procesar cada IP de forma independiente
      Object.entries(agrupadoPorIp).forEach(([ip, items]) => {
        // Ordenar cronológicamente (menor fecha a mayor fecha)
        items.sort((a, b) => new Date(a.fecha).getTime() - new Date(b.fecha).getTime());

        const registroMenor = items[0];
        const registroMayor = items[items.length - 1];

        // Parsear los JSON de enlaces asegurando que sean arrays válidos
        const enlacesMenor: ENLACES[] = registroMenor?.enlaces ? JSON.parse(registroMenor.enlaces) : [];
        const enlacesMayor: ENLACES[] = registroMayor?.enlaces ? JSON.parse(registroMayor.enlaces) : [];

        // Si solo hay 1 registro o la fecha mayor no tiene enlaces, asignamos vacío
        if (enlacesMayor.length === 0) {
          finalObj[ip] = [];
          return;
        }

        // Crear mapa rápido para buscar los datos iniciales (fecha menor) por ifDescr
        const mapMenor: Record<string, { rx: number; tx: number }> = {};
        enlacesMenor.forEach((enlace: ENLACES) => {
          mapMenor[enlace.ifDescr] = {
            rx: parseInt(enlace.RXBytes) || 0,
            tx: parseInt(enlace.TXBytes) || 0
          };
        });

        // 3. Calcular la diferencia (en KB) para el registro de la fecha mayor
        const finalEnlaces: ENLACES[] = enlacesMayor.map((enlace: ENLACES) => {
          const rxMayor = parseInt(enlace.RXBytes) || 0;
          const txMayor = parseInt(enlace.TXBytes) || 0;

          // Si existe en la fecha menor lo restamos, de lo contrario usamos 0
          const rxMenor = mapMenor[enlace.ifDescr]?.rx || 0;
          const txMenor = mapMenor[enlace.ifDescr]?.tx || 0;

          // Cálculo en KB con 2 decimales
          const diffRX = ((rxMayor - rxMenor) / 1024).toFixed(2);
          const diffTX = ((txMayor - txMenor) / 1024).toFixed(2);

          // Limpiar comillas si las tuviese el nombre de la interfaz
          const cleanDescr = enlace.ifDescr.replace(/"/g, "").toUpperCase();

          return {
            ...enlace,
            ifDescr: cleanDescr,
            RXBytes: diffRX,
            TXBytes: diffTX,
            ip: ip
          };
        });

        // Asignar los enlaces procesados a la IP correspondiente
        finalObj[ip] = finalEnlaces;
      });
    }

    statusAxios.value = {
      status: 200,
      data: finalObj,
      showGraphs: showGraphs
    };

  } catch (error) {
    statusAxios.value = { status: 400, data: [], showGraphs: false };
    showConsoleError(error);
  }

  return statusAxios.value;
}



export async function getLast30DaysLTEGestor() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_GESTOR.value.getLast30DaysLTE, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData = response.data;
      const finalObj = ref<ALLDATAINFO>({})
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalData.forEach((item: DATABASEINFO) => {
          const enlaces = JSON.parse(item.enlaces);
          if (enlaces.length > 0) {
            if (!finalObj.value[item.ip]) {
              finalObj.value[item.ip] = {};
            }
            enlaces.forEach((enlace: ENLACES) => {
              const interfaceName = enlace.ifDescr?.split("\"")[1].toUpperCase() ?? 'item';
              if (!finalObj.value[item.ip][interfaceName]) {
                finalObj.value[item.ip][interfaceName] = {
                  rxbytes: [],
                  txbytes: []
                };
              }
              const tiempo = new Date(item.fecha);
              const milliseconds = tiempo.getTime();
              finalObj.value[item.ip][interfaceName].rxbytes.push([milliseconds, parseInt(enlace.RXBytes)]);
              finalObj.value[item.ip][interfaceName].txbytes.push([milliseconds, parseInt(enlace.TXBytes)]);
            });
          }
        })
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}



export async function getItemsTablesGestor() {
  /**
   * Estado de la Petición AXIOS
   */
  const statusAxios = ref()

  await axios
    .get(APIS_LTE.value.getIPLTE, { timeout: TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}` } })
    .then((response) => {
      const finalData: EQUIPOS[] = response.data;
      const finalObj = ref<EQUIPOS[]>([])
      const showGraphs = ref(finalData.length > 0)
      if (finalData.length > 0) {
        finalObj.value = finalData
      }
      statusAxios.value = { status: 200, data: finalObj.value, showGraphs: showGraphs.value }
    })
    .catch(function (error) {
      statusAxios.value = { status: 400, data: [], showGraphs: false }
      showConsoleError(error)
    })
  return statusAxios.value
}